import { actionTypes } from '../constants';
import { selectHasHouses } from '../houses/selectors';
import { selectCurrentName as selectCurrentCityName } from './selectors';

export const currentChanged =
  (city, hasHousesHandler) => (dispatch, getState) => {
    const state = getState();

    const _change = () => {
      dispatch({ type: actionTypes.currentCityChanged, payload: city });
    };

    if (selectHasHouses(state)) {
      hasHousesHandler({
        name: selectCurrentCityName(state),
        onOk: _change,
      });
      return;
    }

    _change();
  };
